var details = {
    text1:"LOS PUNTOS QUE GENERAS POR CADA RESERVA SON:",
    table1: "Marival® Emotions Resort & Suites:",
    pointsTable1: "1 Punto - Suites",
    table2: "Marival® Distinct Luxury Residences:",
    pointsTable2: "1 Punto - 1-Recamara",
    table3: "Marival® Distinct Luxury Residences:",
    pointsTable3: "2 Puntos - 2-Recamaras o más",
    table4: "Marival® Armony Luxury Resort & Suites:",
    pointsTable4: "2 Puntos - cualquier habitación",
    table5: "Marival® Armony Luxury Resort & Suites:",
    pointsTable5: "2 Points - Suites",

    table7: "Marival® Emotions Categoria Resort:",
    pointsTable7: "1 Punto",
    table8: "Marival® Emotions Categoria Resort:",
    pointsTable18: "2 Punto - 7 Noches o más",

    text2: "Puntos de Bonificación:",
    text3: "Family Emotion:",
    text4: "1 punto por categoría reservada.",
    text5: "Sabemos que todas las familias desean toques especiales. Por eso, con el programa Family Emotion de Marival® Resorts, los huéspedes pueden personalizar sus vacaciones familiares perfectas, de principio a fin.",
    text6: "*Se requiere una estancia mínima de 3 noches para generar Puntos. El doble de Puntos no aplica para Puntos Bono.",
    text7: "",
    note: "Nota:",
    noteText: "Los puntos aplican para reservaciones ingresadas a través de cualquier canal y a través de tu operador turístico favorito.",
    noteText1: "Se requiere una estancia mínima de 2 noches para generar Puntos. Los Puntos aplican para estancias de hasta 6 noches; las estancias de 10 noches o más, generan el doble de Puntos. Aplica para reservaciones ingresadas a través de cualquier canal y a través de tu operador turístico favorito.",    
    
    text8: "¿Qué tipo de premio puedo canjear?",
    text9: "Las estancias aplican en categoría Una Recámara en ocupación doble en Marival® Emotions Resort & Suites, categoría de Una Recámara en ocupación doble en Marival® Distinct Luxury Residences y en categoría Habitación Armony en ocupación doble en Marival® Armony Luxury Resort & Suites.",
    text10: "¡Comienza a reservar ahora mismo!",
    text11: "- (Programa Marival Rewards sujeto a cambios sin previo aviso).",
    text12: "- Espere de 3 a 5 semanas para que los premios se entreguen después de la petición.",
    text13: "- sujeto a disponibilidad",
    text14: "Terminos legales:",
    text15: "texto de ejemplo",
    note1:"No pueden usarse más de dos habitaciones en la misma fecha.",
    note2:"(No aplica en, semana santa, pascua, verano, puentes ni días festivos).",
    notApplyGroups:"No aplica para grupos.",

    noteText3:"Se requiere una estadía mínima de 3 noches para comenzar a ganar recompensas. Los puntos obtenidos se aplican para estancias de hasta 9 noches. Para estancias de 10 noches o más gana el doble de puntos. Esto se aplica a todas las reservas directas y también a las realizadas a través de su operador turístico favorito.",

    table100:"Marival® Emotions Resort & Suite",
    table101:"1 Punto",
    table102:"Habitación Resort",
    table103:"Marival® Emotions Resort & Suite",
    table104:"2 Puntos",
    table105:"Suite",
    table106:"Marival® Armony Luxury Resort & Suite",
    table107:"1 Punto",
    table108:"Habitación Lush",
    table109:"Marival® Armony Luxury Resort & Suite",
    table110:"2 Puntos",
    table111:"Habitación Bahía, Armony, Sierra y Allure",
    table112:"Marival® Armony Luxury Resort and Suite",
    table113:"3 Puntos",
    table114:"Suite",
    table115:"Marival® Distinct Luxury Residences",
    table116:"1 Punto",
    table117:"Residencia Estándar",
    table118:"Marival® Distinct Luxury Residences",
    table119:"2 Puntos",
    table120:"Residencia Luxury con vista al mar",
    table121:"Marival® Distinct Luxury Residences",
    table122:"3 Puntos",
    table123:"Demi Pool, Residencia Penthouse y Villas",
    tablefour:"4 Puntos",
    tablesix:"6 Puntos",
    roomcategory:"Categoría de Habitación",
    nights: "noches",
    noteText10:"Se requiere una estancia mínima de 3 noches para generar Puntos. Los Puntos aplican para estancias de hasta 6 noches; las estancias de 7 noches o más, generan el doble de Puntos. Aplica para reservaciones ingresadas a través de cualquier canal y a través de tu operador turístico favorito.",

  /*  text20:"Para detalles de las categorías de cuartos aplicables para estancias de 2 noches, favor de dar clic aquí:",
    text21:"Para detalles de las categorías de cuartos aplicables para estancias de 2 noches, favor de dar clic aquí:",*/
    text20:"",
    text21:"",

    text22:"Para obtener más información sobre <b>Tango</b> y los socios minoristas que ofrece <br/><a href='https://www.tangocard.com/reward-catalog?rewardcountries=US&rewardcategory=gift+card' target='_new'>– HAGA CLIC AQUÍ PARA OBTENER MÁS INFORMACIÓN SOBRE LOS SOCIOS MINORISTAS DE TANGO</a>"

    
}
module.exports = details